import api from "../utils/api";

class AuthService {
  static tokenRequestBody = {
    grant_type: "client_credentials",
    scope: "clientes",
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
  };

  static accessToken = null;

  static fetchAuthToken = () => {
    return new Promise((resolve, reject) => {
      api
        .stringifyPost(api.endpoints.TOKEN, AuthService.tokenRequestBody)
        .then((result) => {
          resolve(result.data.access_token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  static configureRequest = (request) => {
    return new Promise((resolve, reject) => {
      if (request.url.includes(api.endpoints.TOKEN)) {
        resolve(null);
      } else {
        if (AuthService.accessToken == null) {
          this.fetchAuthToken()
            .then((token) => {
              AuthService.accessToken = token;
              resolve(token);
            })
            .catch((error) => reject(error));
        } else {
          resolve(AuthService.accessToken);
        }
      }
    });
  };
}

export default AuthService;
